module.exports = "/packs/media/images/icon_insurance-8daeb317df3e15a4f21346a343412c9e.png";